import React, { useState } from 'react'
import SearchIcon from '@material-ui/icons/Search'
import { makeStyles, InputBase, IconButton, Grid } from '@material-ui/core'
import { useDispatch } from 'react-redux'

import { getPostsBySearch } from '../actions/posts'

const useStyles = makeStyles((theme) => ({
  search: {
    position: 'relative',
    borderRadius: '10px',
    backgroundColor: '#fff',
    boxShadow: `0 0 2px 1px rgb(0 0 0 / 0.2)`,
    '&:hover': {
      boxShadow: `0 0 4px 2px rgb(0 0 0 / 0.25)`,
    },
    marginRight: theme.spacing(3),
    width: '100%',
    [theme.breakpoints.up('md')]: {
      marginLeft: theme.spacing(3),
      width: 'auto',
    },
  },

  searchIcon: {
    padding: theme.spacing(1, 0),
    paddingLeft: '20px',
    pointerEvents: 'none',
    [theme.breakpoints.down('xs')]: {
      paddingLeft: '10px',
    },
  },
  inputRoot: {
    color: 'inherit',
  },
  inputInput: {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(0)}px)`,
    transition: theme.transitions.create('width'),
    width: '100%',
    [theme.breakpoints.up('md')]: {
      width: '50ch',
      height: '3ch',
    },
    [theme.breakpoints.down('xs')]: {
      width: '7ch',
      height: '2ch',
    },
  },
}))

const SearchBox = ({ history, location }) => {
  const classes = useStyles()
  const dispatch = useDispatch()

  const [search, setSearch] = useState('')

  const handleKeyPress = (e) => {
    if (e.keyCode === 13) {
      searchPost()
    }
  }

  const searchPost = (e) => {
    if (search.trim()) {
      dispatch(getPostsBySearch({ search }))
      history.push(`/posts/directory/search?searchQuery=${search}`)
    } else {
      history.push('/')
    }
  }

  return (
    <Grid container className={classes.search}>
      <IconButton
        type='submit'
        className={classes.searchIcon}
        aria-label='search'
        onClick={searchPost}
      >
        <SearchIcon />
      </IconButton>
      <InputBase
        placeholder='Search…'
        onKeyDown={handleKeyPress}
        value={search}
        onChange={(e) => setSearch(e.target.value)}
        classes={{
          root: classes.inputRoot,
          input: classes.inputInput,
        }}
        inputProps={{ 'aria-label': 'search' }}
      />
    </Grid>
  )
}

export default SearchBox
